<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>

      <v-flex m12 v-if="duplicates.length">
          <br>
        <v-card color="red">
          <v-card-title>
            Duplicates ALERT
          </v-card-title>
          <v-data-table
              :headers="[{text:'Username', value:'username'}, {text:'Protocol', value:'protocol'}]"
              :items="duplicates"
              class="elevation-1 v-clickable"
              hide-default-header
              hide-default-footer
               @click:row="selectDuplicate"
            ></v-data-table>
          </v-card>
        </v-flex>

      <v-flex md12>
        <core-table
          hide-upsert
          title="Users"
          ref="userTable"
          :config="config"
          @saved="newUser"
          @edit="editUser"
          @view="editUser" 
          @remove_logic="removeLogic"
          @removed="removed"
        >

        <template slot='headerActions'>
          <slot name='headerActions'/>
            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">

                 <v-btn
                  v-on="on"
                  :loading="loadingExport['excel']"
                  _v-if="$can('upsert', 'user')"
                  color="secondary"
                  @click="export_excel()">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>

              </template>
              <span>Export report</span>
            </v-tooltip>        
        </template>
        
        </core-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import {export_data} from '@/api/export.js'
const { put, get } = require('@/api/base_entity')

export default {
  data () {
    return { 
      config,
      loadingExport: {'excel':false},
      duplicates: []
     }
  },
  async mounted() {
    this.getDuplicates()
  },
  methods: {
     newUser () {
        this.$router.push(`/user/new`)   
    },
    editUser(user) {
      this.$router.push(`/user/${user.id}`)
    },
    async removeLogic(user) {
      const ret = await this.$root.$confirm.open('Confirm LOGIC removal', 'Are you sure to remove this user logically?', { color: 'red' })
      if (ret) {
        put ('user/logic_remove', user.id, user).then( () => {
          this.$refs.userTable.getData()
          this.$root.$emit('openSnackbar', {
            message: 'User correctly removed!',
            color: 'green'
          })

        }).catch( (err) => {
          this.$root.$emit('openSnackbar', {
            message: "Remove user Error : " + err.response.data.message,
            color: 'error'
          })
        }).finally( () => {
          this.getDuplicates()
        })
      }
    },
    removed() {
      this.getDuplicates()
    },
    export_excel() {
      this.loadingExport['excel'] = true
      export_data('user', 'excel').then( () => {
        this.loadingExport['excel'] = false
      }).finally( () => {
        this.loadingExport['excel'] = false
      })
    },
    getDuplicates() {
      get('/user/duplicates').then( ret => {
        this.duplicates = ret.data
      })
    },
    selectDuplicate(duplicate)
    {
      this.config.filterStorage.protocol_id = duplicate.protocol
      this.config.filterStorage.username = duplicate.username
      this.$refs.userTable.getData()
      //console.log(duplicate)
    }
  }
}
</script>

<style>
.v-clickable { cursor: pointer; }
</style>